import { render, staticRenderFns } from "./VideoPaster.vue?vue&type=template&id=31749116&scoped=true"
import script from "./VideoPaster.vue?vue&type=script&lang=js"
export * from "./VideoPaster.vue?vue&type=script&lang=js"
import style0 from "./VideoPaster.vue?vue&type=style&index=0&id=31749116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31749116",
  null
  
)

export default component.exports